<template>
  <v-card elevation="0">
    <v-row>
      <!-- col for image -->
      <v-col cols="12" md="6" class="pa-0">
        <v-img
          max-height="300"
          :src="
            $vuetify.breakpoint.name !== 'sm'
            && $vuetify.breakpoint.name !== 'xs'
            ? require('@/assets/Auction_On_phone.png')
            : require('@/assets/Auction_On_phone_small.png')
          "
        ></v-img>
      </v-col>
      <!-- col for app text -->
      <v-col cols="12" md="6">
        <!-- replace the accountName (wildcard) to the real accountName -->
        <h3 class="primary--text">
          {{$translate('GET_ACCOUNT_APP').replace('accountName', accountName)}}
        </h3>
        <div v-html="$translate('AUCTION_EXPLANATION')"></div>
       <v-row class="px-2">
         <a :href="returnCorrectUrl('IOS')"
            target="_blank"
            rel="noopener noreferrer"
         >
           <img
             class="mr-4"
             src="@/assets/Download_on_the_App_Store.png"
             height="50"
           />
         </a>
         <a :href="returnCorrectUrl('Android')"
            target="_blank"
            rel="noopener noreferrer"
         >
           <img src="@/assets/Download_on_the_Play_Store.png" height="50" />
         </a>
       </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  name: 'EventDetails_AuctionApp',
  props: {

  },
  data() {
    return {
      accountName: '',
    };
  },
  watch: {
  },
  mounted() {
    this.setAccountName();
  },
  methods: {
    returnCorrectUrl(phoneEnv) {
      switch (this.$store.getters['Account/partnerGroupDetails'].PartnerGroupId) {
        case 'PG_68JA4X5B43535T':
          // Van egmond
          if (phoneEnv === 'IOS') return 'https://apps.apple.com/us/app/van-egmond/id1540960062';
          else return 'https://play.google.com/store/apps/details?id=nl.thedrivingforce.VanEgmond';
        case 'PG_DBQKP86YJ624MB':
          // Tussen Jacht en Keuken
          if (phoneEnv === 'IOS') return 'https://apps.apple.com/us/app/tussen-jacht-en-keuken/id1540961797';
          else return 'https://play.google.com/store/apps/details?id=nl.thedrivingforce.BobsSlagerij';
        case 'PG_X2VFYAABFUT8MT':
          // Ruizendaal
          if (phoneEnv === 'IOS') return 'https://apps.apple.com/us/app/ruizendaal/id1539009877';
          else return 'https://play.google.com/store/apps/details?id=nl.thedrivingforce.Ruizendaal';
        case 'PG_9FYLE4FL2P7UPQ':
          // Van Kreuningen
          if (phoneEnv === 'IOS') return 'https://apps.apple.com/us/app/van-kreuningen/id1545554939';
          else return 'https://play.google.com/store/apps/details?id=nl.thedrivingforce.VanKreuningen';
        case 'PG_GV52GFFMJVE92N':
          // Crea-fleur
          if (phoneEnv === 'IOS') return 'https://apps.apple.com/us/app/crea-fleur/id1553102558';
          else return 'https://play.google.com/store/apps/details?id=nl.thedrivingforce.CreaFleur';
      }
    },
    setAccountName() {
      this.accountName = this.$store.getters['Account/partnerGroupDetails'].PartnerGroupDisplayName;
    },
  },
};
</script>
<style scoped lang="scss">
</style>
